<template>
    <div class="flex items-center gap-x-3 rounded-2xl bg-white p-4 shadow-md w-full overflow-hidden">
        <div v-if="iconId" class="min-w-8">
            <Icon class="h-8 w-8" :src="iconId" />
        </div>
        <div class="w-full">
            <div class="text-xl font-semibold leading-snug tracking-tighter truncate">
                {{ formattedValue }}<span v-if="suffix && hasValue"class="ml-0.5 text-xs font-medium text-gray-400">{{ suffix }}</span>
            </div>
            <div class="text-sm text-gray-600 leading-tight truncate">{{ label }}</div>
        </div>
    </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { i18n } from '@/plugins/internationalization/i18n';

const props = defineProps<{
    label: string;
    value: number;
    suffix?: string;
    iconId?: number;
    // Always show exactly this many decimals (e.g. 28.0); otherwise the 'decimal' format drops trailing zeros.
    fixedDecimals?: number;
}>();

const hasValue = computed(() => Number.isFinite(props.value));

const formattedValue = computed(() => {
    if (!hasValue.value) return '—';
    const rounded = Number(props.value.toFixed(1));
    if (props.fixedDecimals === undefined) return i18n.global.n(rounded, 'decimal');
    return i18n.global.n(rounded, { style: 'decimal', minimumFractionDigits: props.fixedDecimals, maximumFractionDigits: props.fixedDecimals });
});
</script>
